module.exports = __webpack_public_path__ + "img/sq-16.41a64f6b.jpg";